//Modules
export const Modules = Object.freeze([
  { label: 'Account', value: 0 },
  { label: 'Campaign', value: 1 },
  { label: 'Contact', value: 2 },
  { label: 'Deal', value: 3 },
  { label: 'Lead', value: 4 },
]);

//Lead
export const LeadIndustry = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Application Service Provider', value: 1 },
  { label: 'Data Telecom OEM', value: 2 },
  { label: 'ERP', value: 3 },
  { label: 'Government/Military', value: 4 },
  { label: 'Large Enterprise', value: 5 },
  { label: 'Managed Service Provider', value: 6 },
  { label: 'Manufacturing', value: 7 },
  { label: 'Retail', value: 8 },
  { label: 'Technology', value: 9 },
  { label: 'Web Development', value: 10 },
  { label: 'Other', value: 11 },
]);

export const LeadRating = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Acquired', value: 1 },
  { label: 'Active', value: 2 },
  { label: 'Market Failed', value: 3 },
  { label: 'Project Cancelled', value: 4 },
  { label: 'Shut Down', value: 5 },
]);

export const LeadSource = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Advertisement', value: 1 },
  { label: 'Cold Call', value: 2 },
  { label: 'Employee Referral', value: 3 },
  { label: 'External Referral', value: 4 },
  { label: 'Online Store', value: 5 },
  { label: 'Partner', value: 6 },
  { label: 'Public Relations', value: 7 },
  { label: 'Trade Show', value: 8 },
  { label: 'Web Download', value: 9 },
  { label: 'Web Research', value: 10 },
  { label: 'LinkedIn', value: 11 },
  { label: 'Other', value: 12 },
]);

export const LeadStatus = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Not Contacted', value: 1 },
  { label: 'Attempted to Contact', value: 2 },
  { label: 'Contacted', value: 3 },
  { label: 'Qualified', value: 4 },
  { label: 'Disqualified', value: 5 },
]);

//Task
export const TaskStatus = Object.freeze([
  { label: 'Not Started', value: 0 },
  { label: 'Deferred', value: 1 },
  { label: 'In Progress', value: 2 },
  { label: 'Completed', value: 3 },
  { label: 'Waiting for input', value: 4 }
]);

export const TaskPriority = Object.freeze([
  { label: 'High', value: 0 },
  { label: 'Highest', value: 1 },
  { label: 'Low', value: 2 },
  { label: 'Lowest', value: 3 },
  { label: 'Normal', value: 4 }
]);

//Account
export const AccountRating = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Acquired', value: 1 },
  { label: 'Active', value: 2 },
  { label: 'Market Failed', value: 3 },
  { label: 'Project Cancelled', value: 4 },
  { label: 'Shut Down', value: 5 },
]);

export const AccountType = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Analyst', value: 1 },
  { label: 'Competitor', value: 2 },
  { label: 'Customer', value: 3 },
  { label: 'Investor', value: 4 },
  { label: 'Distributor', value: 5 },
  { label: 'Partner', value: 6 },
  { label: 'Integrator', value: 7 },
  { label: 'Press', value: 8 },
  { label: 'Prospect', value: 9 },
  { label: 'Other', value: 10 },
  { label: 'Reseller', value: 11 },
  { label: 'Supplier', value: 12 },
  { label: 'Vendor', value: 13 }
]);

export const AccountIndustry = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'ASP (Application Service Provider)', value: 1 }, // Application Service Provider
  { label: 'DataTelecom', value: 2 },
  { label: 'Government', value: 3 },
  { label: 'ERP', value: 4 },
  { label: 'LargeEnterprise', value: 5 },
  { label: 'MSP', value: 6 },
  { label: 'NetworkEquipmentEnterprise', value: 7 },
  { label: 'NonManagement', value: 8 },
  { label: 'OpticalNetworking', value: 9 },
  { label: 'ServiceProvider', value: 10 },
  { label: 'Other', value: 11 }
]);

export const AccountOwnership = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Other', value: 1 },
  { label: 'Private', value: 2 },
  { label: 'Public', value: 3 },
  { label: 'Subsidiary', value: 4 },
  { label: 'Partnership', value: 5 },
  { label: 'Government', value: 6 }
]);

//Campaigns
export const CampaignType = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Public', value: 1 },
  { label: 'InHouse', value: 2 }
]);

export const CampaignStatus = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Planning', value: 1 },
  { label: 'Active', value: 2 },
  { label: 'InActive', value: 3 },
  { label: 'Complete', value: 4 }
]);

//Deals
export const DealStage = Object.freeze([
  { label: 'Qualification', value: 0, probability: 10 },
  { label: 'Needs Analysis', value: 1, probability: 20 },
  { label: 'Value Proposition', value: 2, probability: 40 },
  { label: 'Identify Decision Makers', value: 3, probability: 60 },
  { label: 'Proposal/Price Quote', value: 4, probability: 75 },
  { label: 'Negotiation/Review', value: 5, probability: 90 },
  { label: 'Closed Won', value: 6, probability: 100 },
  { label: 'Closed Lost', value: 7, probability: 0 },
  { label: 'Closed Lost Competition', value: 8, probability: 0 }
]);

export const DealType = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Existing Business', value: 1 },
  { label: 'New Business', value: 2 }
]);

export const DealSource = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Advertisement', value: 1 },
  { label: 'ColdCall', value: 2 },
  { label: 'EmployeeReferral', value: 3 },
  { label: 'ExternalReferral', value: 4 },
  { label: 'Partner', value: 5 },
  { label: 'OnlineStore', value: 6 },
  { label: 'PublicRelations', value: 7 },
  { label: 'TradeShow', value: 8 },
  { label: 'SalesEmailAlias', value: 9 },
  { label: 'SeminarPartner', value: 10 },
  { label: 'InternalSeminar', value: 11 },
  { label: 'WebDownload', value: 12 },
  { label: 'WebResearch', value: 13 },
  { label: 'Chat', value: 14 }
]);

export const DealReasonForLoss = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Expectation Mismatch', value: 1 },
  { label: 'Price', value: 2 },
  { label: 'Unqualified Customer', value: 3 },
  { label: 'Lack Of Response', value: 4 },
  { label: 'Missed Follow Ups', value: 5 },
  { label: 'Wrong Target', value: 6 },
  { label: 'Competition', value: 7 },
  { label: 'Future Interest', value: 8 },
  { label: 'Requires Certified Program', value: 9},
  { label: 'Timing Not Suitable', value: 10},
  { label: 'Proposal Rejected Internally', value: 11},
  { label: 'Enrolled In Another Course', value: 12},
  { label: 'Other', value: 13 },
]);

//LeadCampaign
export const MemberStatus = Object.freeze([
  { label: 'Planned', value: 0 },
  { label: 'Invited', value: 1 },
  { label: 'Sent', value: 2 },
  { label: 'Received', value: 3 },
  { label: 'Opened', value: 4 },
  { label: 'Responded', value: 5 },
  { label: 'Bounced', value: 6 },
  { label: 'Opted Out', value: 7 }
]);

//invitation
export const InvitationStatus = Object.freeze([
  { label: 'Pending', value: 0 },
  { label: 'Accepted', value: 1 },
  { label: 'Expired', value: 2 }
]);

export const UserRoles = Object.freeze([
  { label: 'Admin', value: 0 },
  { label: 'User', value: 1 },
  { label: 'Manager', value: 2 },
  { label: 'No Access', value: 3 },
  { label: 'ID User', value: 4 }
]);

//Proposals
export const ProposalStatus = Object.freeze([
  { label: 'Received', value: 0 },
  { label: 'InProgress', value: 1 },
  { label: 'Sent', value: 2 }
]);

export const DealStatus = Object.freeze([
  { label: 'None', value: 0 },
  { label: 'Won', value: 1 },
  { label: 'Lost', value: 2 }
]);

